import Swal from 'sweetalert2';

function send_webview_data (params) {
    if (window.ReactNativeWebView !== undefined) {
      window.ReactNativeWebView.postMessage( JSON.stringify(params));
    } else {
      // Swal.fire("웹뷰와 통신하는 동안 오류가 발생했습니다.");
      console.log("[웹뷰 통신오류] 웹뷰가 동작하지 않습니다.");
    }
};

export default send_webview_data;